import React from 'react';
import './CommunityPolicing.css';

const CommunityPolicing = () => {
  return (
    <section className="community-policing">
      <div className="policing-wrapper">
        <h2 className="section-title">Community Policing</h2>
        <p>
          Our local government actively collaborates with law enforcement agencies and the community
          to promote peace and order. Through town hall meetings, neighborhood watch programs, and
          vigilant collaboration, we ensure a proactive and responsive security structure.
        </p>
      </div>
    </section>
  );
};

export default CommunityPolicing;